import { OutputSlotFillingRuleInput } from '@automata/wfb-api/src/apis/wfbApiSchemas';

import { getRangeSize, parseSlotSpec } from '../../utils/slots';

export function serializeHamiltonOutputSlot(
  startSpec: string | number | null | undefined,
  endSpec: string | number | null | undefined
): OutputSlotFillingRuleInput | number {
  const endSize = getRangeSize(endSpec);
  const ends = parseSlotSpec(endSpec);

  if (endSize > 1) {
    return {
      behavior: 'use_range',
      slot_range: {
        start_slot: ends[0] as number,
        end_slot: ends[ends.length - 1] as number,
      },
    };
  }

  if (ends.length === 1) {
    return ends[0] as number;
  }

  const starts = parseSlotSpec(startSpec);
  if (starts.length >= 1) {
    return starts[0] as number;
  }

  return 1;
}
